module.exports = {
  i18n: {
    defaultLocale: "pl",
    locales: ["en", "pl", "ru"],
  },
};
